// Module
var code = "<div class=\"ToolBarPreview\"> <label data-bind=\"attr: { title: Label }\"><img src=\"img/Custom/sql-256.png\"> <!-- ko text: GetControlTypeTranslatedName() --><!-- /ko --></label> </div> ";
// Exports
export default code;